// extracted by mini-css-extract-plugin
module.exports = {"alert":"ih","alertIcon":"ii","formContainer":"ij","formContainerInner":"ik","successIcon":"il","footer":"im","footerItem":"in"};